/*
 * <cdx-express-checkout> – "Bezahlen mit Amazon" button (snippets/cdx-amazon-express-btn.liquid):
 * adds the product of the surrounding product form to the cart and goes straight to checkout.
 * Errors (e.g. sold out, quantity) are shown in the product form's error area.
 */
if (!customElements.get("cdx-express-checkout")) {
  customElements.define(
    "cdx-express-checkout",
    class CdxExpressCheckout extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector("button");
        this.onClick = this.onClick.bind(this);
        this.button?.addEventListener("click", this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener("click", this.onClick);
      }

      async onClick() {
        const form = this.closest("form");
        if (!form) return;
        const productForm = this.closest("product-form");
        productForm?.handleErrorMessage?.();
        this.setLoading(true);

        try {
          const response = await fetch(window.routes?.cart_add_url || "/cart/add", {
            method: "POST",
            headers: { Accept: "application/javascript", "X-Requested-With": "XMLHttpRequest" },
            body: new FormData(form),
          });
          const result = await response.json();
          if (!response.ok || result.status) {
            throw new Error(result.description || result.message || response.statusText);
          }
          window.location.href = "/checkout";
        } catch (error) {
          this.setLoading(false);
          if (productForm?.handleErrorMessage) productForm.handleErrorMessage(error.message);
          else console.error("Express Checkout:", error);
        }
      }

      setLoading(loading) {
        this.toggleAttribute("loading", loading);
        this.button.disabled = loading;
      }
    }
  );
}
